import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  STORE_INVOICE_FETCH_PREVIEW_MERCHANT,
  STORE_INVOICE_PREVIEW,
  STORE_STATUS_INITIALIZED,
} from 'constants/store'
import { ErrorStore, MerchantInvoice } from '@types'
import { Payload } from 'stores'
import { createGenericSlice, GenericState } from 'stores/generics/create-slice'
import { createReducers, ExtraReducers } from 'stores/generics/create-reducers'
import { STORE_INVOICE_FETCH_PREVIEW_BUYER_MOCK_INITIALIZED } from '@fixtures/stores/invoice'

export type MerchantInvoiceState = MerchantInvoice

type State = GenericState<MerchantInvoiceState>

export const initialState: State = {
  data: {
    ...STORE_INVOICE_FETCH_PREVIEW_BUYER_MOCK_INITIALIZED.data,
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchMerchantInvoice = createAsyncThunk<
  MerchantInvoiceState,
  Promise<MerchantInvoice>,
  Payload
>(
  STORE_INVOICE_FETCH_PREVIEW_MERCHANT,
  async (promise: Promise<MerchantInvoice>, { rejectWithValue }) => {
    try {
      const response = await promise
      return response
    } catch (e: unknown) {
      const { code, message } = e as ErrorStore
      return rejectWithValue({ code, message })
    }
  }
)

const extraReducers: ExtraReducers = createReducers<
  MerchantInvoiceState,
  MerchantInvoice,
  Payload
>(fetchMerchantInvoice, initialState.data)

const invoicesSlice = createGenericSlice({
  name: STORE_INVOICE_PREVIEW,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = invoicesSlice

const { clear } = actions

export { clear }

export default reducer
